import { createStateContext } from '../../factory'

export const [WalletProvider, useWallet] = createStateContext({
  withdrawAmount: 0,
  country: 'US',
})
